import { handleResponse, handleError } from "./apiUtils";
import { API, graphqlOperation } from 'aws-amplify';
import moment from 'moment';
import * as queries from '../graphql/queries';
import * as mutations from '../graphql/mutations';
import getOffsetTime from '../utils/getOffsetTime';
import demoParams from '../__test__/demoParams';
import _ from 'underscore';

export const FETCH_BRANCHES_BY_COMPANY_ID_SUCCESS = "FETCH_BRANCHES_BY_COMPANY_ID_SUCCESS";
export const FETCH_DIVISIONS_BY_BRANCH_ID_SUCCESS = "FETCH_DEPARTMENTS_BY_BRANCH_ID_SUCCESS"
export const FETCH_DEPARTMENTS_BY_COMPANY_ID_BRANCH_ID_DIVISION_ID_SUCCESS = "FETCH_DEPARTMENTS_BY_COMPANY_ID_BRANCH_ID_DIVISION_ID_SUCCESS";
export const FETCH_RESOURCE_COLLECTIONS_BY_USER_ID_GENERAL_ID_COMPANY_ID_SUCCESS = "FETCH_RESOURCE_COLLECTIONS_BY_USER_ID_GENERAL_ID_COMPANY_ID_SUCCESS";
export const FETCH_TOUR_APPROVALS_SUCCESS = "FETCH_TOUR_APPROVALS_SUCCESS";
export const FETCH_TIME_KEEPER_REVERSALS_BY_RESOURCE_DAY_TYPE_ID = "FETCH_TIME_KEEPER_REVERSALS_BY_RESOURCE_DAY_TYPE_ID";


export async function getBranchesByCompanyId(parameters) {

  parameters.ipAddress = '27.0.0.1';

  let response = await API.graphql(graphqlOperation(queries.approvalsApIgetBranchesByCompanyId, parameters))
    .catch(handleError);

  return response.data.approvalsAPIgetBranchesByCompanyId;
}

export async function getDivisionsByBranchId(parameters) {

  parameters.ipAddress = '27.0.0.1';

  let response = await API.graphql(graphqlOperation(queries.approvalsApIgetDivisionsByBranchId, parameters))
    .catch(handleError);

  return response.data.approvalsAPIgetDivisionsByBranchId;
}

export async function getDepartmentsByCompanyIdBranchIdDivisionId(parameters) {

  parameters.ipAddress = '27.0.0.1';

  let response = await API.graphql(graphqlOperation(queries.approvalsApIgetDepartmentsByCompanyIdBranchIdDivisionId, parameters))
    .catch(handleError);

  return response.data.approvalsAPIgetDepartmentsByCompanyIdBranchIdDivisionId;
}

export async function getResourceCollectionsByUserIdGeneralIdCompanyId(parameters) {

  parameters.ipAddress = '27.0.0.1';

  let response = await API.graphql(graphqlOperation(queries.approvalsApIgetResourceCollectionsByUserIdGeneralIdCompanyId, parameters))
    .catch(handleError);

  return response.data.approvalsAPIgetResourceCollectionsByUserIdGeneralIdCompanyId;
}

export async function getTourApprovals(parameters) {

  parameters.ipAddress = '27.0.0.1';

  let response = await API.graphql(graphqlOperation(queries.approvalsApIgetTourApprovals, parameters))
    .catch(handleError);
  return response.data.approvalsAPIgetTourApprovals;
}

export async function getTimeKeeperReversalsByResourceDayTypeId(parameters) {

  parameters.ipAddress = '27.0.0.1';

  let response = await API.graphql(graphqlOperation(queries.approvalsApIgetTimeKeeperReversalCheckByTourId, parameters))
    .catch(handleError);

  return response.data.approvalsAPIgetTimeKeeperReversalCheckByTourId;
}

export async function getTourIsDirectBillingCheckByTourId(parameters) {

  parameters.ipAddress = '27.0.0.1';

  let response = await API.graphql(graphqlOperation(queries.approvalsApIgetTourIsDirectBillingCheckByTourId, parameters))
    .catch(handleError);
  return response.data.approvalsAPIgetTourIsDirectBillingCheckByTourId;
}

export async function getContactInfoByTourId(parameters) {

  parameters.ipAddress = '27.0.0.1';

  let response = await API.graphql(graphqlOperation(queries.approvalsApIgetContactInfoCheckByTourId, parameters))
    .catch(handleError);
  return response.data.approvalsAPIgetContactInfoCheckByTourId;
}

export async function createTimeKeeperReversal(parameters) {

  parameters.ipAddress = '27.0.0.1';

  let response = await API.graphql(graphqlOperation(mutations.approvalsApIcreateTimeKeeperReversal, parameters))
    .catch(handleError);
  return response.data.approvalsAPIcreateTimeKeeperReversal;
}

export async function updateTourApprovals(parameters) {
  
  parameters.ipAddress = '27.0.0.1';
  
  let response = await API.graphql(graphqlOperation(mutations.approvalsApIupdateTourApprovals, parameters))
    .catch(handleError);
  return response.data.approvalsAPIgetTourApprovals;
}



// WEBPACK FOOTER //
// ./src/api/approvalsApi.js